import api from './api';

class WorkOrderService {
  // Get all work orders with pagination and filtering
  static async getWorkOrders(params = {}) {
    try {
      const response = await api.get('/work-orders', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching work orders:', error);
      throw this.handleError(error);
    }
  }

  // Get work order by ID
  static async getWorkOrder(id) {
    try {
      const response = await api.get(`/work-orders/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching work order:', error);
      throw this.handleError(error);
    }
  }

  // Create new work order
  static async createWorkOrder(workOrderData) {
    try {
      const response = await api.post('/work-orders', workOrderData);
      return response.data;
    } catch (error) {
      console.error('Error creating work order:', error);
      throw this.handleError(error);
    }
  }

  // Update work order
  static async updateWorkOrder(id, workOrderData) {
    try {
      const response = await api.put(`/work-orders/${id}`, workOrderData);
      return response.data;
    } catch (error) {
      console.error('Error updating work order:', error);
      throw this.handleError(error);
    }
  }

  // Delete work order
  static async deleteWorkOrder(id) {
    try {
      const response = await api.delete(`/work-orders/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting work order:', error);
      throw this.handleError(error);
    }
  }

  // Handle API errors
  static handleError(error) {
    if (error.response) {
      // Server responded with error status
      return {
        message: error.response.data?.message || 'An error occurred',
        status: error.response.status,
        data: error.response.data
      };
    } else if (error.request) {
      // Request was made but no response received
      return {
        message: 'Network error - please check your connection',
        status: 0
      };
    } else {
      // Something else happened
      return {
        message: error.message || 'An unexpected error occurred',
        status: 0
      };
    }
  }
}

export default WorkOrderService;

